<template>
	<div id="listing-token-amount-form">
		<div class="tw-rounde tw-mt-6">
			<div class="tw-items-center tw-text-center tw-pb-8">
				<div>
					<p class="tw-text-sm tw-text-gray tw-mb-4">Current Payout Value</p>
					<h1 class="tw-text-secondary tw-text-3xl tw-font-bold tw-mb-4">
						{{formatAmountToDollar( tokenPayoutDetails?.payoutValue, 2, tokenInfo.currency)}}
					</h1>
					<p class="tw-text-xs tw-text-primary tw-mb-6">Annual Return Rate: {{ tokenInfo.interest }}%</p>
					<p class="tw-mb-6 tw-text-xs"><span class="bg-gray-light tw-rounded-full tw-p-2">Total Expected Payout: <span class="tw-font-bold"> </span>{{formatAmountToDollar( tokenPayoutDetails?.totalPayout, 2, tokenInfo.currency)}}</span></p>
					<DropDown
						title="Investment Summary"
						subTitle=""
						class="tw-flex tw-items-start tw-mt-4"
						@active-dropdown="setDropdownStatus"
						>
						<template v-slot:content>
							<div class="tw-rounded tw-mt-8">
								<div class="tw-items-center tw-text-center tw-pb-8">
									<div class="tw-flex tw-flex-row tw-justify-center tw-text-secondary tw-mb-4">
										<div class="tw-mr-2 tw-px-10 tw-py-4 bg-gray-light tw-rounded-200">
											<p class="tw-text-secondary tw-text-base tw-font-bold tw-mb-2">
												{{ tokenInfo.payout_frequency }}
											</p>
											<p class="tw-text-xs tw-text-gray">Frequency</p>
										</div>
										<div class="tw-px-10 tw-py-4 bg-gray-light tw-rounded-600">
											<p class="tw-text-secondary tw-text-base tw-font-bold tw-mb-2">
												{{ formatToStringDate(tokenInfo?.last_paid, "hideDay") }}
											</p>
											<p class="tw-text-xs tw-text-gray tw-rounded">Last Paid Date</p>
										</div>
									</div>
									<div class="tw-flex tw-flex-row tw-justify-center tw-text-secondary tw-mb-4">
										<div class="tw-mr-2 tw-px-6 tw-py-4 bg-gray-light tw-rounded-600">
											<p class="tw-text-secondary tw-text-base tw-font-bold tw-mb-2">
												{{formatAmountToDollar((tokenBalance * tokenInfo?.price?.buy), 2, tokenInfo.currency)}}
											</p>
											<p class="tw-text-xs tw-text-gray">Investment Amount</p>
										</div>
										<div class="tw-px-4 tw-py-4 bg-gray-light tw-rounded-200">
											<p class="tw-text-secondary tw-text-base tw-font-bold tw-mb-2">
												{{ tokenInfo?.tenor }} Days
											</p>
											<p class="tw-text-xs tw-text-gray tw-rounded">Investment Period</p>
										</div>
									</div>
									<div class="tw-flex tw-flex-row tw-justify-center bg-gray-light tw-mx-4 tw-text-secondary tw-mb-2">
										<div class="tw-px-12 tw-py-4 tw-rounded-600">
											<p class="tw-text-secondary tw-text-base tw-font-bold tw-mb-2">
												{{ formatToStringDate(tokenInfo?.maturity) }}
											</p>
											<p class="tw-text-xs tw-text-gray">Maturity Date</p>
										</div>
									</div>
								</div>
							</div>
						</template>
					</DropDown>
					<DropDown
						title="Fees and Charges"
						subTitle=""
						class="tw-flex tw-items-start tw-mt-4"
						@active-dropdown="setDropdownStatus"
						>
						<template v-slot:content>
							<div class="tw-rounded tw-mt-8">
								<div class="tw-items-center tw-text-center tw-pb-8">
									<!-- <div class="tw-flex tw-flex-row tw-justify-center tw-text-secondary tw-mb-4">
										<div class="tw-mr-2 tw-px-6 tw-py-4 bg-gray-light tw-rounded-600">
											<p class="tw-text-secondary tw-text-base tw-font-bold tw-mb-2">
												{{formatAmountToDollar((tokenBalance * tokenInfo?.price?.buy), 2, tokenInfo.currency)}}
											</p>
											<p class="tw-text-xs tw-text-gray">Investment Amount</p>
										</div>
										<div class="tw-px-4 tw-py-4 bg-gray-light tw-rounded-200">
											<p class="tw-text-secondary tw-text-base tw-font-bold tw-mb-2">
												{{ tokenInfo?.tenor }} Days
											</p>
											<p class="tw-text-xs tw-text-gray tw-rounded">Investment Period</p>
										</div>
									</div> -->
									<div class="tw-flex tw-flex-row tw-justify-center bg-gray-light tw-mx-4 tw-text-secondary tw-mb-2">
										<div class="tw-px-12 tw-py-4 tw-rounded-600">
											<p class="tw-text-secondary tw-text-base tw-font-bold tw-mb-2">
												10%
											</p>
											<p class="tw-text-xs tw-text-gray">Witholding Tax</p>
										</div>
									</div>
								</div>
							</div>
						</template>
					</DropDown>
					<p class="tw-mb-2 tw-text-sm tw-text-gray">Upcoming payouts: Next payout scheduled for</p>
					<p class="tw-mb-2 tw-text-sm tw-text-gray"><span class="tw-font-bold">{{ tokenPayoutDetails?.nextPayout? formatToStringDate(tokenPayoutDetails?.nextPayout) : "None" }}</span>, amount: <span class="tw-font-bold">{{formatAmountToDollar( tokenPayoutDetails?.payoutValue, 2, tokenInfo.currency)}}</span></p>
					<div
						v-for="(transaction, index) in transactions"
						:key="index"
					>
						<div 
							class="tw-items-start tw-bg-white tw-rounded tw-border tw-border-gray-200 tw-py-2 tw-px-2 tw-mt-8"
							v-if="transaction.type.toLowerCase() == 'interest' && `${transaction.token._id}` == `${tokenInfo._id}`"
						>
							<div class="tw-flex tw-items-start tw-mt-4 tw-text-success">
								<svg width="45" height="45" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
									<g clip-path="url(#clip0_21542_51249)">
									<path d="M26.6128 0.714469C19.5464 0.214969 12.4536 0.214969 5.38721 0.714469C4.17856 0.805323 3.04256 1.32661 2.18551 2.18367C1.32845 3.04072 0.807163 4.17672 0.716309 5.38537C0.216309 12.4517 0.216309 19.5446 0.716309 26.611C0.807163 27.8196 1.32845 28.9556 2.18551 29.8127C3.04256 30.6697 4.17856 31.191 5.38721 31.2819C12.4535 31.7826 19.5465 31.7826 26.6128 31.2819C27.8215 31.191 28.9575 30.6697 29.8145 29.8127C30.6716 28.9556 31.1929 27.8196 31.2837 26.611C31.7837 19.5446 31.7837 12.4517 31.2837 5.38537C31.1929 4.17672 30.6716 3.04072 29.8145 2.18367C28.9575 1.32661 27.8215 0.805323 26.6128 0.714469Z" fill="#F0FDF4"/>
									<path d="M21.293 9.29243L11 19.5853V14.9281C11 14.6629 10.8946 14.4086 10.7071 14.221C10.5196 14.0335 10.2652 13.9281 10 13.9281C9.73478 13.9281 9.48043 14.0335 9.29289 14.221C9.10536 14.4086 9 14.6629 9 14.9281V21.9994C9.0045 22.2632 9.1113 22.515 9.29787 22.7016C9.48444 22.8881 9.73619 22.9949 10 22.9994H17.0713C17.3365 22.9994 17.5909 22.8941 17.7784 22.7065C17.9659 22.519 18.0713 22.2646 18.0713 21.9994C18.0713 21.7342 17.9659 21.4799 17.7784 21.2923C17.5909 21.1048 17.3365 20.9994 17.0713 20.9994H12.4141L22.707 10.7064C22.8892 10.5178 22.99 10.2652 22.9877 10.003C22.9854 9.74083 22.8802 9.49002 22.6948 9.30461C22.5094 9.1192 22.2586 9.01403 21.9964 9.01176C21.7342 9.00948 21.4816 9.11027 21.293 9.29243Z" fill="url(#paint0_linear_21542_51249)"/>
									</g>
									<defs>
									<linearGradient id="paint0_linear_21542_51249" x1="16" y1="8.78643" x2="16" y2="23.0974" gradientUnits="userSpaceOnUse">
									<stop stop-color="#18C19F"/>
									<stop offset="1" stop-color="#8BF3AF"/>
									</linearGradient>
									<clipPath id="clip0_21542_51249">
									<rect width="32" height="32" fill="white"/>
									</clipPath>
									</defs>
								</svg>
								<div class="tw-ml-2 tw-flex tw-flex-col">
									<span class="tw-font-bold tw-text-black">Total Payout Amount</span>
									<p class="tw-font-bold" style="text-align: start">+{{formatAmountToDollar( transaction.volume, 2, tokenInfo.currency)}}</p>
								</div>								
							</div>
							<div class="tw-flex tw-items-start tw-mt-4 tw-text-success">
								<div class="tw-flex tw-flex-row tw-justify-start tw-text-secondary tw-mb-4">
									<div class="tw-mr-2 tw-px-4 tw-py-2 tw-border-r-2 tw-border-gray-light tw-rounded-600">
										<p class="tw-text-xs tw-text-gray tw-mb-2">Pay Out Date</p>
										<p class="tw-text-secondary tw-text-xs tw-font-bold ">
											{{ formatToStringDate(transaction?.createdAt) }}
										</p>
									</div>
									<div class="tw-mr-2 tw-px-4 tw-py-2 tw-border-r-2 tw-border-gray-light tw-rounded-600">
										<p class="tw-text-xs tw-text-gray tw-mb-2">Total Invested</p>
										<p class="tw-text-secondary tw-text-xs tw-font-bold ">
											{{formatAmountToDollar((tokenBalance * tokenInfo?.price?.buy), 2, tokenInfo.currency)}}
										</p>
									</div>
									<div class="tw-px-4 tw-py-2 tw-rounded-200">
										<p class="tw-text-xs tw-text-gray tw-rounded tw-mb-2">Tokens</p>
										<p class="tw-flex tw-text-secondary tw-text-xs tw-font-bold ">
											<img
												src="@/assets/img/token-icon.svg"
												class="tw-h-4 tw-mr-1"
												alt="asset"
											/>
											{{ transaction?.price.toLocaleString() }}
										</p>
									</div>
								</div>							
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Btn from "@/components/general/BtnComponent.vue";
import DropDown from "@/components/invest/dropdown";
import { formatAmountToDollar, formatToStringDate } from "@/utils/helpers";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
	name: "PayoutBreakdown",

	emits: ["completed"],

	components: { Btn, DropDown },

	data() {
		return {
			dollarValid: false,
			tokenValid: false,
			payload: { tokens: "", dollarAmount: "" },
			totalAmount: "",
			availableTokens: 0,
			interestTransactions: []
		};
	},

	computed: {
		...mapState({
			tokenInfo: (state) => state.TokenModule.tokenInfo,
			tokenBalance: (state) => state.TokenModule.tokenBalance,
			tokenPayoutDetails: (state) => state.TokenModule.tokenPayoutDetails,
			transactions: (state) => state.organisationModule.transactions.filter(transaction => transaction.type.toLowerCase() == "interest" && `${transaction.token._id}` == `${this.tokenInfo._id}`),
		}),
		...mapGetters("TokenModule", ["subscriptionStatus"]),
		...mapGetters("organisationModule", ["transactions"]),
		// ...mapGetters("investorModule", ["membershipStatus", "walletBalance"]),
		// balance() {
		// 	return this.walletBalance.find(
		// 		(wallet) => wallet.currency === this.currency
		// 	).balance;
		// },
		// currency() {
		// 	return this.tokenInfo.currency || "USD";
		// },
	},

	mounted() {
		// this.calculateDetails();
		this.getInterestTransactions();
	},

	methods: {
		...mapActions("organisationModule", [
			"getTransactions",
		]),
		...mapActions("TokenModule", [
			"getTokenBalance",
		]),
		formatAmountToDollar,
		formatToStringDate,
		setDropdownStatus(title) {
			this.$emit("dropdownTitle", title);
		},
		async getInterestTransactions() {
			const transactions = await this.getTransactions({ page: 1, limit: 15, tokenId: this.tokenInfo._id });
			console.log({transactions})
		},
	},
};
</script>

<style lang="scss" scoped>
.bg-gray-light {
	background-color: #f7f7f7;
}
</style>
